module.exports = __webpack_public_path__ + "img/05.7a39e3fa.png";